import { Store } from "pullstate";

export const globalComponentName = "global";

export type ComponentError = {
  [key: string]: any;
};

export type ErrorStore = Record<string, ComponentError>;

const errorStore = new Store<ErrorStore>({});

export default errorStore;